import React, { memo, useCallback, useMemo } from 'react';
import { Container, Text } from '@pixi/react';
import { getGameImages } from '../../../core/helpers/getGameImages';
import IconBackGround from '../../common/iconBackGround';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { isoStandard } from '../../../core/helpers/isoStandard';
import { isMobile } from '../../../core/helpers/isMobile';
import { abbrNum } from '../../../core/helpers/abbrNumber';
import { applicationStore } from '../../../store/applicationStore';
import {userInfoStore} from "../../../store/userInfoStore";

const ClassicQuickBetsList = memo(({ x, y, quickBetsByPage, quickBetMargin }) => {
  const { isShowLicenseMode, isDemo } = applicationStore;
  const { setSelectedQuickBet, setIsShowQuickBetsListPopup } = bettingPartStore;
  const {
    quickBetPopupItem,
    quickBetPopupItemHovered,
    quickBetPopupItemPressed,
    quickBetPopupItemSelected,
  } = useMemo(() => {
    return getGameImages();
  }, []);

  const additionalBackGroundImages = useMemo(() => {
    return {
      iconBgDefault: quickBetPopupItem,
      iconBgDisabled: quickBetPopupItem,
      iconBgHovered: quickBetPopupItemHovered,
      iconBgPressed: quickBetPopupItemPressed,
      iconBgSelected: quickBetPopupItemSelected,
    };
  }, [
    quickBetPopupItem,
    quickBetPopupItemPressed,
    quickBetPopupItemSelected,
    quickBetPopupItemHovered,
  ]);

  const handleSelect = useCallback(
    (e, value) => {
      setSelectedQuickBet(value);
      setIsShowQuickBetsListPopup(false);
    },
    [setSelectedQuickBet, setIsShowQuickBetsListPopup]
  );

  const numberStandard = useCallback((number) => {
    return number >= 100000 ? abbrNum(number) : isoStandard(number, true);
  }, []);

  return (
    <Container x={x} y={y}>
      {quickBetsByPage.map((el, index) => {
        return (
          <IconBackGround
            x={index * quickBetMargin}
            key={el}
            additionalBackGroundImages={additionalBackGroundImages}
            handleSelect={(e) => handleSelect(e, el)}
          >
            <Text
              text={`${
                isShowLicenseMode && !isDemo ? userInfoStore.currencyIcon : ''
              }${numberStandard(+el)}`}
              style={{ fill: '#FFFFFF', fontSize: isMobile() ? 18 : 20 }}
              anchor={0.5}
              resolution={2}
            />
          </IconBackGround>
        );
      })}
    </Container>
  );
});
export default ClassicQuickBetsList;
